export function shortCountries(fullName: string): string {

  switch (fullName) {
    case "Rest of the world": return "RW";
    case "India": return "IN";
    case "Indonesia": return "ID";
    case "Russian Federation": return "RU";
    case "China": return "CN";
    case "United States": return "US";
    case "Brazil": return "BR";
    case "Bangladesh": return "BD";
    case "Thailand": return "TH";
    case "Argentina": return "AR";
    case "Pakistan": return "PK";
    case "Canada": return "CA";
    case "Australia": return "AU";
    case "Russia and Ukraine": return "RaU";
    case "Turkey": return "TR"; 
    case "U - UA & CAU": return "EU-28";
    case "Vietnam": return "VN";
    case "Mexico": return "MX";
    case "Ukraine": return "UA";
    case "France": return "FR";
    case "Germany": return "DE";
    case "South Africa": return "ZA";
    case "Czech Republic": return "CZ";
    case "Spain": return "ES";
    case "United Kingdom": return "GB";
    case "Poland": return "PL";
    case "Romania": return "RO";
    case "Italy": return "IT";
    case "Hungary": return "HU";
    case "Greece": return "GR";
    case "Turkey": return "TR";
    case "Belgium": return "BE";
    case "Netherlands": return "NL";
    case "Portugal": return "PT";
    case "Chile": return "CL";
    case "Japan": return "JP";
    case "Korea, Democratic People'S Rep": return "KN";
    case "Korea, Republic Of": return "KR";
    default: return fullName;
  }
} 